var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiterightMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47121 3.15771L9.47348 4.15886L4.78499 8.84193L1.89453 5.95488L2.8968 4.95373L4.78499 6.83967L8.47121 3.15771Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiterightMore);
export default __webpack_public_path__ + "static/media/whiterightMore.af228250c0ca3c267330351a82ea78d7.svg";
export { ForwardRef as ReactComponent };